"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountContextProvider = exports.useAccount = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _agent = require("@deosite/agent");
var _TokenProvider = require("../common/TokenProvider");
var _LanguageProvider = require("../common/LanguageProvider");
var _MessageHandlerProvider = require("../common/MessageHandlerProvider");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _mapAddressNew = _interopRequireDefault(require("@deosite/helpers/mapAddressNew"));
var _CartProvider = require("./CartProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AccountContext = /*#__PURE__*/_react["default"].createContext();
var defaultAddress = {
  customer: null,
  shippingAddress: null,
  billingAddress: null,
  email: null
};
var AccountContextProvider = function AccountContextProvider(props) {
  var _useState = (0, _react.useState)(defaultAddress),
    accountDataState = _useState[0],
    setAccountDataState = _useState[1];
  var _useCart = (0, _CartProvider.useCart)(),
    cart = _useCart.cart;
  (0, _react.useEffect)(function () {
    var _JSON$parse;
    setAccountDataState((_JSON$parse = JSON.parse(sessionStorage.getItem("accountData"))) !== null && _JSON$parse !== void 0 ? _JSON$parse : defaultAddress);
  }, [cart]);
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var websiteIds = global.__appConfig__.websiteIds;
  var translations = {
    passwordSaved: (0, _langLibrary["default"])("Password saved"),
    nameSaved: (0, _langLibrary["default"])("Firstname and Lastname saved"),
    addressSaved: (0, _langLibrary["default"])("Address saved"),
    addressDeleted: (0, _langLibrary["default"])("Address deleted")
  };
  var setAccountFromCart = function setAccountFromCart() {
    if (!(accountDataState !== null && accountDataState !== void 0 && accountDataState.email)) {
      var _JSON$parse2;
      setAccountDataState((_JSON$parse2 = JSON.parse(sessionStorage.getItem("accountData"))) !== null && _JSON$parse2 !== void 0 ? _JSON$parse2 : defaultAddress);
    }
  };
  var setNewDataAfterLogin = function setNewDataAfterLogin() {
    var _sessionStorage, _accountDataNew$custo, _accountDataState$cus;
    var accountDataNew = JSON.parse((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("accountData"));
    if ((accountDataNew === null || accountDataNew === void 0 ? void 0 : (_accountDataNew$custo = accountDataNew.customer) === null || _accountDataNew$custo === void 0 ? void 0 : _accountDataNew$custo.email) !== (accountDataState === null || accountDataState === void 0 ? void 0 : (_accountDataState$cus = accountDataState.customer) === null || _accountDataState$cus === void 0 ? void 0 : _accountDataState$cus.email)) {
      setAccountDataState(accountDataNew);
    }
  };
  var refreshData = function refreshData(data) {
    sessionStorage.setItem("accountData", JSON.stringify(data));
    setAccountDataState(data);
  };
  var clearAccountData = function clearAccountData() {
    var _sessionStorage2;
    (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.removeItem("accountData");
    setAccountDataState(defaultAddress);
  };
  var saveName = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(values) {
      var newData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _agent.requests.put(global.__appConfig__.customerDataUrl, {
                customer: {
                  firstname: values.firstName,
                  lastname: values.lastName,
                  email: accountDataState.customer.email,
                  website_id: websiteIds[language.language]
                }
              }, token, language);
            case 3:
              newData = _context.sent;
              handleMessage(translations.nameSaved, false, false);
              refreshData(_objectSpread(_objectSpread({}, accountDataState), {}, {
                customer: newData
              }));
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              handleMessage(_context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function saveName(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var savePassword = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(values) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _agent.requests.put("/customers/me/password", {
                currentPassword: values.oldPassword,
                newPassword: values.newPassword
              }, token, language);
            case 3:
              handleMessage(translations.passwordSaved, false, false);
              _context2.next = 9;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              handleMessage(_context2.t0);
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));
    return function savePassword(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var saveAddress = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(id, values) {
      var _accountDataState$cus2, _accountDataState$cus3;
      var addresses, isCompany, newAddress, newData, lastAddedAddress;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              addresses = [];
              (_accountDataState$cus2 = accountDataState.customer) === null || _accountDataState$cus2 === void 0 ? void 0 : (_accountDataState$cus3 = _accountDataState$cus2.addresses) === null || _accountDataState$cus3 === void 0 ? void 0 : _accountDataState$cus3.map(function (address) {
                if ((address === null || address === void 0 ? void 0 : address.id) !== parseInt(id)) {
                  addresses.push(address);
                }
              });
              isCompany = values.fields.isCompany;
              newAddress = {
                id: id,
                firstname: values.fields.firstName,
                lastname: values.fields.lastName,
                street: Array.isArray(values.fields.street) ? values.fields.street : [values.fields.street],
                postcode: values.fields.postalCode,
                city: values.fields.city,
                telephone: values.fields.phone,
                country_id: values.fields.country.id,
                defaultBilling: values.isDefaultBilling,
                defaultShipping: values.isDefaultShipping,
                company: isCompany ? values.fields.companyName : "",
                vat_id: isCompany ? values.fields.vatId : ""
              };
              addresses.push(newAddress);
              _context3.prev = 5;
              _context3.next = 8;
              return _agent.requests.put(global.__appConfig__.customerDataUrl, {
                customer: {
                  firstname: accountDataState.customer.firstname,
                  lastname: accountDataState.customer.lastname,
                  email: accountDataState.customer.email,
                  website_id: websiteIds[language.language],
                  addresses: addresses
                }
              }, token, language);
            case 8:
              newData = _context3.sent;
              handleMessage(translations.addressSaved, false, false);
              lastAddedAddress = !accountDataState.hasAddressInCart && (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, addresses === null || addresses === void 0 ? void 0 : addresses[addresses.length - 1]), {}, {
                email: accountDataState.customer.email,
                country: [{
                  id: values.fields.country.id
                }]
              }));
              if (newAddress.defaultBilling) {
                refreshData(_objectSpread(_objectSpread({}, accountDataState), {}, {
                  customer: newData,
                  billingAddress: (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, newAddress), {}, {
                    email: accountDataState.customer.email,
                    country: [{
                      id: values.fields.country.id
                    }]
                  }))
                }));
              } else if (newAddress.defaultShipping) {
                refreshData(_objectSpread(_objectSpread({}, accountDataState), {}, {
                  customer: newData,
                  shippingAddress: (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, newAddress), {}, {
                    email: accountDataState.customer.email,
                    country: [{
                      id: values.fields.country.id
                    }]
                  }))
                }));
              } else {
                refreshData(_objectSpread(_objectSpread({}, accountDataState), {}, {
                  customer: newData
                }));
              }
              _context3.next = 17;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](5);
              handleMessage(_context3.t0);
            case 17:
              return _context3.abrupt("return", true);
            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[5, 14]]);
    }));
    return function saveAddress(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var deleteAddress = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(id) {
      var _accountDataState$cus4;
      var addresses;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              addresses = (_accountDataState$cus4 = accountDataState.customer) === null || _accountDataState$cus4 === void 0 ? void 0 : _accountDataState$cus4.addresses;
              addresses.splice(addresses.findIndex(function (address) {
                return address.id === parseInt(id);
              }), 1);
              _context4.prev = 2;
              _context4.next = 5;
              return _agent.requests.put(global.__appConfig__.customerDataUrl, {
                customer: {
                  firstname: accountDataState.customer.firstname,
                  lastname: accountDataState.customer.lastname,
                  email: accountDataState.customer.email,
                  website_id: websiteIds[language.language],
                  addresses: addresses
                }
              }, token, language);
            case 5:
              handleMessage(translations.addressDeleted, false, false);
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](2);
              handleMessage(_context4.t0);
            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 8]]);
    }));
    return function deleteAddress(_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  return __jsx(AccountContext.Provider, {
    value: {
      accountData: accountDataState,
      clearAccountData: clearAccountData,
      setNewDataAfterLogin: setNewDataAfterLogin,
      saveName: saveName,
      savePassword: savePassword,
      saveAddress: saveAddress,
      refreshData: refreshData,
      deleteAddress: deleteAddress,
      setAccountFromCart: setAccountFromCart
    }
  }, props.children);
};
exports.AccountContextProvider = AccountContextProvider;
var useAccount = function useAccount() {
  return (0, _react.useContext)(AccountContext);
};
exports.useAccount = useAccount;